import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/userCenter',
  title: window.language["homepage.navBar.userCenter"],
  component: dynamicWrapper(app, [import('./model'), import('../../Material/Material/model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/NavBar/UserCenter/index.js